import { rm } from 'utils';
import styles from './styles.scss';
import cn from 'classnames';

type DisplayAddressProps = {
  name?: string;
  street?: string;
  zipCode?: string;
  city?: string;
  phone?: string;
  email?: string;
  classnames?: string;
};

export const DisplayAddress = ({
  name,
  email,
  phone,
  city,
  street,
  zipCode,
  classnames
}: DisplayAddressProps) => {
  return (
    <div className={cn(styles.address, classnames)}>
      <div>
        <strong>{rm('checkout_address')}</strong>
        <br />
        {name}
        <br />
        {street}
        <br />
        {zipCode} {city}
      </div>
      <div>
        <strong>{rm('checkout_cellphone')}</strong>
        <br />
        {phone}
        <br />
        <strong>{rm('sip_email')}</strong>
        <br />
        {email}
      </div>
    </div>
  );
};
